import {FC, useCallback, useState} from "react";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import PeopleIcon from "@mui/icons-material/People";
import {ListItemText} from "../Menu.tsx";
import ListItemButton from "@mui/material/ListItemButton";
import Modal from "./GroupMembership/Modal.tsx";

export type GroupMembershipButtonProps = {
    profileID: string
    onClick?: () => void
}

const GroupMembershipButton: FC<GroupMembershipButtonProps> = ({profileID, onClick}) => {
    const [dialogOpen, setDialogOpen] = useState<boolean>(false)

    const handleDialogOpen = useCallback(() => {
        setDialogOpen(true)
        onClick?.()
    }, [onClick])
    const handleDialogClose = useCallback(() => setDialogOpen(false), [])

    return (
        <>
            <ListItem disablePadding>
                <ListItemButton onClick={handleDialogOpen}>
                    <ListItemIcon>
                        <PeopleIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Toegang beheren"/>
                </ListItemButton>
            </ListItem>
            <Modal open={dialogOpen} profileID={profileID} onClose={handleDialogClose} />
        </>
    )
}

export default GroupMembershipButton
